import ApplyFormPage from "@modules/career-form/pages/ApplyFormPage"

export default ApplyFormPage
